import { z } from "zod";
import { supportFormSchema } from "./creator-profile";
import { toast } from "sonner";
import API from "@/lib/constants/axios";
import { CREATE_ORDER } from "@/lib/constants/api";

export async function handleSupport(
  values: z.infer<typeof supportFormSchema>,
  recaptchaToken: string,
) {
  const order: any = structuredClone(values);
  delete order.follower_message;
  order["notes"] = { follower_message: values.follower_message };
  order["currency"] = "INR";
  order["recaptchaToken"] = recaptchaToken;
  order["is_anonymous"] = values.is_anonymous;
  const res = await createOrder({ ...order });

  if (!res.success) {
    toast.error(res.message || "Something went wrong!", {
      position: "top-center",
    });
  } else {
    const { order, paymentBlock } = res.data;
    const options = {
      key: process.env.NEXT_PUBLIC_RAZORPAY_APP_KEY_ID,
      amount: values.amount,
      currency: "INR",
      name: process.env.NEXT_PUBLIC_APP_NAME,
      description: "",
      image: "https://example.com/your_logo",
      order_id: order.id,
      callback_url: "",
      prefill: {
        name: values.name,
        email: values.email,
        contact: values.phone,
      },
      notes: {
        user_id: order.user_id,
      },
      theme: {
        color: "#3254a8",
      },
    };

    // if (window && window !== undefined) {
    const paymentObject = (window as any).Razorpay(options);
    paymentObject.open();
  }
}

export async function createOrder(payload: any) {
  try {
    const res = await API.post(`${CREATE_ORDER}`, payload);

    return {
      success: true,
      message: "",
      data: res.data,
    };
  } catch (error) {
    return {
      message: "",
      success: false,
      data: null,
    };
  }
}
